import { defineComponent } from "vue";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";

export default defineComponent({
  name: "DataTable",
  props: {
    id: Number,
    diagnostics: Array,
    isLoaging: Boolean,
  },
  components: {
    OverlayButton,
  },
  data: () => ({}),
  computed: {
    fields() {
      return [
        {
          label: "Diagnóstico",
          key: "code_name",
        },
        {
          label: "Calificaciones",
          key: "qualifications_count",
        },
        {
          label: "Última calificación",
          key: "last_qualification_date",
        },
        {
          label: "APT",
          key: "apt",
        },
        {
          label: "PCL",
          key: "pcl",
        },
        {
          label: "",
          key: "options",
        },
      ];
    },
  },
  watch: {
    id() {
      this.getData();
    },
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      if (this.id < 1) return;
      this.processing = true;
      setTimeout(() => {
        this.processing = false;
      }, 3000);
    },
    findItem(id) {
      const me = this;
      me.$router.push({
        name: "detailDiagnostic",
        params: { employee_id: me.id, diagnostic_id: id, is_edit: false },
      });
    },
    editItem(id) {
      const me = this;
      me.$router.push({
        name: "editDiagnostic",
        params: { employee_id: me.id, diagnostic_id: id, is_edit: true },
      });
    },
    deleteItem(id) {
      const me = this;
      me.$emit("deleteItem", id);
    },
    qualification(item) {
      const me = this;
      me.$router.push({
        name: "listQualification",
        params: { employee_id: me.id, diagnostic_id: item?.id },
      });
    },
    changePage(page = 1) {
      if (page < 1) return;
      alert(page);
    },
  },
});
